import { CampaignCoverImageFields } from '@ms/yammer-graphql';

import { CampaignCoverImage } from '../../../state/types';

export const processCampaignCoverImage: (value: CampaignCoverImageFields) => CampaignCoverImage = (value) => ({
  id: value.id,
  coverImageLabel: value.hashTags[0],
  coverImageUrlTemplate: value.coverImageUrlTemplate,
  coverImageUrlTemplateRequiresAuthentication: value.coverImageUrlTemplateRequiresAuthentication,
  hasDefaultCoverImage: value.hasDefaultCoverImage,
  defaultCoverImageUrlTemplate: value.defaultCoverImageUrlTemplate,
});
